import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ overflowX: 'hidden' }}>
          <Navbar />
          <Hero />
          <Stats />
          <Services />
          <About />
          <Portfolio />
          <Testimonials />
          <Contact />
          <Footer />
        </Box>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
